import type { Variants } from "framer-motion";

export const ease = {
  duration: 0.2,
  ease: [0.2, 0, 0, 1] as const,
};

export const fadeInUpVariants: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0 },
};

export const mobileMenuVariants: Variants = {
  hidden: { x: "-100%" },
  visible: { x: 0, transition: ease },
  exit: { x: "-100%", transition: { ...ease, duration: 0.2 } },
};

export const overlayVariants: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.2 } },
  exit: { opacity: 0, transition: { duration: 0.15 } },
};
